var link_viewer_default = {
  "fontElementMap": "HkBFO",
  "link": "_8h3Wj",
  "linkInEditor": "WclmW",
  "linkInViewer": "_2X-Ph",
  "toolbarUrlContainer": "o-hSb",
  "toolbarUrl": "WjCDU",
  "toolbarUrlAnchor": "fvyUn"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
